export default () => {
    const accordionsTeam = document.querySelectorAll('.js-accordionTeam'); 
    
    if(accordionsTeam){
        accordionsTeam.forEach( accordion => {
            let accordionParent = accordion.parentNode;
            const memberDescription = accordionParent.parentNode.querySelector('.Card__Description');
 
            accordion.addEventListener('click', () => {
                memberDescription.classList.toggle('is-active');
                accordion.classList.toggle('is-active');
            })
            
        });
         
    
    }
};